export enum SwapProvider {
  ICPSWAP = 'ICPSwap',
  ODIN = 'Odin',
  JUPITER = 'Jupiter',
  LIFI = 'LI.FI',
  STEALTHEX = 'StealthEX',
  ONESEC = 'OneSec',
  DFINITY = 'Dfinity',
  YUSAN = 'Yusan',
  HYPERLIQUID = 'HyperLiquid',
}

export interface SwapProviderQuote {
  provider: SwapProvider
  price: number
  priceHuman: number
  slippage?: number
  metadata?: {
    [key: string]: any
  }
}

export interface SwapProviderQuoteFetchError {
  provider: SwapProvider
  error: string
}

export interface SwapTokenPair {
  swapCanisterPrincipal: string
  feeRate: number
  token0: {
    principal: string
    standard: string
  }
  token1: {
    principal: string
    standard: string
  }
  provider: SwapProvider
}

export enum SwapStep {
  Transfer = 'transfer',
  Approve = 'approve',
  Deposit = 'deposit',
  Swap = 'swap',
  Withdraw = 'withdraw',
  ErrorFallback = 'errorFallback',
}

export interface InputError {
  inputFieldError?: string
  buttonError: string
}
